export default __webpack_public_path__ + "static/media/zoo.d2137f52.svg";